import React, { useMemo } from 'react';
import { Button, Space, Table, Typography } from 'antd';

const isCompletedStatus = (status) => String(status || '').toLowerCase() === 'completed';

const parseJobDate = (job) => {
  const raw = job?.selectedDateString || job?.date;
  if (!raw) return null;

  if (typeof raw === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(raw)) {
    const [dd, mm, yyyy] = raw.split('-');
    const parsed = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const parseJobDateTime = (job) => {
  const baseDate = parseJobDate(job);
  if (!baseDate) return null;

  const slots = Array.isArray(job?.slots) ? job.slots : [];
  const timeText = slots[0] || job?.starttime || job?.time;

  if (!timeText || typeof timeText !== 'string') {
    return new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 0, 0, 0, 0);
  }

  const match = timeText.match(/^(\d{1,2}):(\d{2})$/);
  if (!match) {
    return new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 0, 0, 0, 0);
  }

  const hour = Number(match[1]);
  const minute = Number(match[2]);
  return new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), hour, minute, 0, 0);
};

export default function MyJobsView({ jobs, columns, loading, onRefresh, currentUserId }) {
  const rows = useMemo(() => {
    if (!currentUserId) return [];

    return jobs
      .filter((job) => String(job?.assigneeId || '') === String(currentUserId))
      .sort((a, b) => {
        const aCompleted = isCompletedStatus(a?.status);
        const bCompleted = isCompletedStatus(b?.status);
        if (aCompleted !== bCompleted) return aCompleted ? 1 : -1;

        const aDate = parseJobDateTime(a);
        const bDate = parseJobDateTime(b);
        if (aDate && bDate) return bDate.getTime() - aDate.getTime();
        if (aDate) return -1;
        if (bDate) return 1;
        return 0;
      });
  }, [jobs, currentUserId]);

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={12}>
      <Space style={{ width: '100%', justifyContent: 'space-between' }}>
        <Typography.Text strong>
          {currentUserId ? `Assigned to me (${rows.length})` : 'Current user not available'}
        </Typography.Text>
        <Button onClick={onRefresh} loading={loading}>
          Refresh
        </Button>
      </Space>

      <Table
        columns={columns}
        dataSource={rows}
        loading={loading}
        pagination={{ pageSize: 10 }}
        scroll={{ x: 900 }}
        locale={{ emptyText: currentUserId ? 'No jobs assigned to you' : 'User details unavailable' }}
      />
    </Space>
  );
}
